<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
    <div class="container-header-inner-list">
        <div class="row">
            <div class="col-sm-6">
                <h1 class="title-default">Chaves de Acesso</h1>
                <p>Nesta tela você pode gerenciar as chaves de acesso para integrações</p>
            </div>
            <div class="col-sm-6">
                <a type="button" mat-flat-button class="btn-primary btn-add-right"
                    routerLink="/integracao/chave-acesso/cadastrar">
                    <mat-icon>add</mat-icon>
                    Nova Chave
                </a>
            </div>
        </div>
        <form class="form" [formGroup]="model" (ngSubmit)="clickPesquisar()" class="search-area">
            <div class="row">
                <div class="col-12 col-md-6">
                    <mat-form-field appearance="outline">
                        <mat-label>Pesquisar</mat-label>
                        <input matInput formControlName="pesquisa" type="text" placeholder="Pesquisar por nome">
                        <button mat-icon-button matSuffix type="button" (click)="clickPesquisar()"
                            aria-label="Pesquisar">
                            <mat-icon>search</mat-icon>
                        </button>
                    </mat-form-field>
                </div>
            </div>
        </form>

        @if(this.listaChaveAcessoResponse && this.listaChaveAcessoResponse.listaChaveAcesso.length > 0){
        <table mat-table [dataSource]="_dataSource">

            <ng-container matColumnDef="idChaveAcesso">
                <th mat-header-cell *matHeaderCellDef> ID </th>
                <td mat-cell *matCellDef="let element"> {{element.idChaveAcesso}} </td>
            </ng-container>

            <ng-container matColumnDef="chaveAcessoNome">
                <th mat-header-cell *matHeaderCellDef> Nome </th>
                <td mat-cell *matCellDef="let element"> {{element.chaveAcessoNome}} </td>
            </ng-container>

            <ng-container matColumnDef="nomeUsuario">
                <th mat-header-cell *matHeaderCellDef> Usuário </th>
                <td mat-cell *matCellDef="let element"> {{element.nomeUsuario}} </td>
            </ng-container>

            <ng-container matColumnDef="ativo">
                <th mat-header-cell *matHeaderCellDef> Status </th>
                <td mat-cell *matCellDef="let element"> {{element.ativo ? 'Ativo':'Inativo'}} </td>
            </ng-container>

            <ng-container matColumnDef="chave">
                <th mat-header-cell *matHeaderCellDef> Chave </th>
                <td mat-cell *matCellDef="let element">
                    <span>*****</span>
                    <button mat-icon-button (click)="copiarChave(element.chave)" matTooltip="Copiar Chave">
                        <mat-icon>content_copy</mat-icon>
                    </button>
                </td>
            </ng-container>

            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef class="text-center w-actions">Ações</th>
                <td mat-cell *matCellDef="let element" class="text-center w-actions">
                    <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Ações">
                        <span class="material-symbols-outlined">more_horiz</span>
                    </button>
                    <mat-menu #menu="matMenu">
                        <button mat-menu-item
                            [routerLink]="['/integracao/chave-acesso/cadastrar', {idChaveAcesso: element.idChaveAcesso}]">
                            <span class="material-symbols-outlined">edit</span>
                            <span>Editar</span>
                        </button>
                        <button mat-menu-item
                            (click)="abrirModalExcluir(element.idChaveAcesso, element.chaveAcessoNome)">
                            <span class="material-symbols-outlined">delete</span>
                            <span>Excluir</span>
                        </button>
                    </mat-menu>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

        <div class="col-12 text-center ver-mais-pesquisa">
            <button mat-button [disabled]="_ultimaPagina" (click)="proximaPagina()">
                @if (_isLoading === true) {
                <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
                }
                @else{
                <span class="material-symbols-outlined">keyboard_arrow_down</span>
                Ver mais
                }
            </button>
        </div>
        } @else if(_isLoading) {
        <app-loading-box-default-list></app-loading-box-default-list>
        } @else {
        <app-empty-list [title]="'Nenhuma chave de acesso encontrada'"></app-empty-list>
        }
    </div>
</div>